import { useState } from "react";
import axios from "axios";
import { Check, MessageCircle, Send } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const InterestForm = () => {
  const [form, setForm] = useState({ name: "", whatsapp: "", note: "" });
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  const update = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    const digits = form.whatsapp.replace(/\D/g, "");
    if (digits.length < 10 || digits.length > 15) {
      setError("Please enter a valid WhatsApp number with country code, e.g. +91 98765 43210.");
      return;
    }
    setStatus("sending");
    try {
      await axios.post(`${API}/trip-interest`, { trip: "deoria-taal", name: form.name.trim(), whatsapp: form.whatsapp.trim(), note: form.note.trim() });
      setStatus("sent");
    } catch (err) {
      setStatus("idle");
      setError(err.response?.data?.detail?.[0]?.msg || "Something went wrong. Please try again or message us on WhatsApp.");
    }
  };

  return (
    <section className="dt-interest" id="interest" data-testid="deoria-interest">
      <div className="dt-interest-copy">
        <p className="dt-kicker">Not ready to book yet?</p>
        <h2>Leave your number, I&#39;ll reach out.</h2>
        <p>Share your name and WhatsApp number and Priyanka will message you personally with pricing, pickup details and answers to anything on your mind. No spam, no group broadcasts.</p>
      </div>
      {status === "sent" ? (
        <div className="dt-interest-card is-sent" data-testid="deoria-interest-success">
          <div className="dt-interest-check"><Check size={22} /></div>
          <h3>Got it, {form.name.split(" ")[0]}.</h3>
          <p>Expect a WhatsApp message from Priyanka within a day or two. Until then, start thinking about warm socks.</p>
        </div>
      ) : (
        <form className="dt-interest-card" onSubmit={submit} data-testid="deoria-interest-form">
          <label>Your name
            <input name="name" value={form.name} onChange={update} required maxLength={120} placeholder="How shall I call you?" data-testid="interest-name-input" />
          </label>
          <label>WhatsApp number
            <input name="whatsapp" type="tel" inputMode="tel" value={form.whatsapp} onChange={update} required placeholder="+91 98765 43210" data-testid="interest-whatsapp-input" />
          </label>
          <label>Anything you&#39;d like to ask? <span>(optional)</span>
            <textarea name="note" value={form.note} onChange={update} maxLength={1000} rows={3} placeholder="Travelling solo, first trek, dietary needs..." data-testid="interest-note-input" />
          </label>
          {error && <p className="dt-interest-error" role="alert" data-testid="interest-error">{error}</p>}
          <button type="submit" className="dt-btn dt-btn-yellow" disabled={status === "sending"} data-testid="interest-submit-button">
            {status === "sending" ? "Sending..." : <><Send size={18} /> Keep me posted</>}
          </button>
          <p className="dt-interest-alt"><MessageCircle size={14} /> Prefer to just message? <a href="https://wa.me/919871906396" target="_blank" rel="noopener noreferrer" data-testid="interest-whatsapp-link">Open WhatsApp</a></p>
        </form>
      )}
    </section>
  );
};
